import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { Component } from "@angular/core";
import { Subscription } from "rxjs";
import { ColorEvent } from "ngx-color";
import { Input } from "@angular/core";
import {
  BASE_COMPONENT_KEY,
  TEXT_COMPONENT_KEY,
  LISTING_IMAGE_COMPONENT_KEY,
  LISTING_BARCODE_COMPONENT_KEY,
  LISTING_INFORMATION_COMPONENT_KEY,
  LISTING_TABLE_COMPONENT_KEY,
} from "@app/components/editor/workspace/golden-layout-definitions";
declare var $: any;

@Component({
  selector: "golden-layout-configuration",
  templateUrl: "./golden-layout-configuration.component.html",
})
export class GoldenLayoutConfigurationComponent {
  @Input()
  metafieldsTags: string[] = [];
  type: string;
  state: any;
  subscription: Subscription;
  BASE_COMPONENT_KEY = BASE_COMPONENT_KEY;
  TEXT_COMPONENT_KEY = TEXT_COMPONENT_KEY;
  LISTING_IMAGE_COMPONENT_KEY = LISTING_IMAGE_COMPONENT_KEY;
  LISTING_INFORMATION_COMPONENT_KEY = LISTING_INFORMATION_COMPONENT_KEY;
  LISTING_TABLE_COMPONENT_KEY = LISTING_TABLE_COMPONENT_KEY;
  LISTING_BARCODE_COMPONENT_KEY = LISTING_BARCODE_COMPONENT_KEY;

  barcodeTypes = [
    {
      key: "upce",
      title: "UPC-E (7 digits)",
    },
    {
      key: "ean8",
      title: "EAN 8 (8 digits)",
    },
    {
      key: "upca",
      title: "UPC-A/GTIN-12 (12 digits)",
    },
    {
      key: "ean13",
      title: "EAN 13 (13 digits)",
    },
    {
      key: "itf14",
      title: "ITF-14/GTIN-14 (14 digits)",
    },
    {
      key: "code39",
      title: "Code 39 (no limitation)",
    },
    {
      key: "code128",
      title: "Code 128 (no limitation)",
    },
  ];

  constructor(private goldenLayoutService: GoldenLayoutService) {
    this.subscription = this.goldenLayoutService
      .getSelection()
      .subscribe((selection) => {
        this.type = selection.type;
        this.state = selection.state;
      });
  }

  colorChanged(style, field, $event: ColorEvent) {
    style[field] = $event.color.hex;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  get padding() {
    return ("" + this.state.style.padding).replace("%", "");
  }
  @Input() set padding(value: string) {
    this.state.style.padding = value + "%";
  }

  removeColumn(column) {
    this.state.columns.splice(this.state.columns.indexOf(column), 1);
  }

  checkBorderSelected(style, borders) {
    var contains = true;
    borders.forEach((border) => {
      contains = contains && style[border] && style[border] != 0;
    });
    return contains;
  }

  addColumn() {
    this.state.columns.push({
      header_html: "Enter Your Label",
      content_html: "Put Your Info",
      style: {
        width: "10%",
      },
    });
  }

  applyGlobalStyle(style) {
    this.state.columns.forEach((column) => {
      column.style = Object.assign({}, column.style, style);
    });
  }

  updateColumnWidth(value, column) {
    column.style.width = value + "%";
  }
}
